// Butikk-modulen (Phase 72): Bokmål-nøkkel → Nynorsk. Berre UI-tekst – varenamn, skildringar og notat frå arrangøren blir aldri omsette.
export const NN_SHOP = {
  // Felles
  "Butikk": "Butikk",
  "Tilleggsmodul": "Tilleggsmodul",
  "Butikken vår": "Butikken vår",
  "Se butikken": "Sjå butikken",
  "Se vare": "Sjå vare",
  "Få igjen": "Få att",
  "{n} igjen": "{n} att",
  "Utsolgt": "Utselt",
  "Ikke tilgjengelig": "Ikkje tilgjengeleg",
  "Skjult": "Skjult",
  "Aktiv": "Aktiv",
  "Lav beholdning": "Låg behaldning",
  "På lager": "På lager",
  "Henting": "Henting",
  "Sending": "Sending",
  "Henting hos arrangøren": "Henting hos arrangøren",
  "Sending i posten": "Sending i posten",
  "Faktura": "Faktura",
  "Vipps": "Vipps",
  "Gratis": "Gratis",
  "Frakt": "Frakt",
  "Totalt": "Totalt",
  "Varer": "Varer",
  "Vare": "Vare",
  "Ordre": "Ordre",
  "Ordrer": "Ordrar",
  "Innstillinger": "Innstillingar",
  "Oversikt": "Oversikt",
  "Pris": "Pris",
  "Lager": "Lager",
  "Status": "Status",
  "Handlinger": "Handlingar",
  "Lagre": "Lagre",
  "Lagrer …": "Lagrar …",
  "Avbryt": "Avbryt",
  "Slett": "Slett",
  "Rediger": "Rediger",
  "Tilbake": "Tilbake",
  "Søk": "Søk",
  "Alle": "Alle",
  "Last ned faktura (PDF)": "Last ned faktura (PDF)",
  "Prøv igjen": "Prøv igjen",
  "Noe gikk galt": "Noko gjekk gale",

  // Offentleg: marknadsplass
  "Butikk – varer fra arrangørene": "Butikk – varer frå arrangørane",
  "Bøker, suvenirer og andre varer fra lokale arrangører. Du handler direkte med arrangøren – betal med Vipps eller få faktura.": "Bøker, suvenirar og andre varer frå lokale arrangørar. Du handlar direkte med arrangøren – betal med Vipps eller få faktura.",
  "Søk etter vare eller arrangør": "Søk etter vare eller arrangør",
  "Alle arrangører": "Alle arrangørar",
  "{n} varer": "{n} varer",
  "{n} vare": "{n} vare",
  "Ingen varer ennå": "Ingen varer enno",
  "Ingen varer passet søket": "Ingen varer passa søket",
  "Når arrangører åpner butikken sin, dukker varene opp her.": "Når arrangørar opnar butikken sin, dukkar varene opp her.",
  "Nullstill søk": "Nullstill søk",
  "Kunne ikke laste butikken": "Kunne ikkje laste butikken",

  // Offentleg: arrangørbutikk / vare
  "Fant ikke butikken": "Fann ikkje butikken",
  "Denne arrangøren har ikke åpnet butikken ennå.": "Denne arrangøren har ikkje opna butikken enno.",
  "Til alle butikker": "Til alle butikkar",
  "Se arrangementer": "Sjå arrangement",
  "Henting: {place}": "Henting: {place}",
  "Sending: {price}": "Sending: {price}",
  "Betal med Vipps eller faktura": "Betal med Vipps eller faktura",
  "Betal med Vipps": "Betal med Vipps",
  "Bestill med faktura": "Bestill med faktura",
  "Fant ikke varen": "Fann ikkje varen",
  "Varen er ikke tilgjengelig lenger.": "Varen er ikkje tilgjengeleg lenger.",
  "Flere varer fra {org}": "Fleire varer frå {org}",
  "Selges av": "Seljast av",
  "Antall": "Tal",
  "Færre": "Færre",
  "Flere": "Fleire",
  "Levering": "Levering",
  "Betaling": "Betaling",
  "Hentes etter avtale hos arrangøren": "Hentast etter avtale hos arrangøren",
  "Sendes til adressen du oppgir": "Blir sendt til adressa du oppgir",
  "Du betaler i Vipps-appen nå": "Du betaler i Vipps-appen no",
  "Du får faktura (PDF) på e-post – forfall {days} dager": "Du får faktura (PDF) på e-post – forfall {days} dagar",
  "Navn": "Namn",
  "E-post": "E-post",
  "Telefon (valgfritt)": "Telefon (valfritt)",
  "Adresse": "Adresse",
  "Postnummer": "Postnummer",
  "Poststed": "Poststad",
  "Melding til selger (valgfritt)": "Melding til seljaren (valfritt)",
  "Kjøp nå – {amount}": "Kjøp no – {amount}",
  "Bestill med faktura – {amount}": "Bestill med faktura – {amount}",
  "Sender deg til Vipps …": "Sender deg til Vipps …",
  "Bestiller …": "Bestiller …",
  "Varen er utsolgt": "Varen er utseld",
  "Butikken tar ikke imot bestillinger akkurat nå.": "Butikken tek ikkje imot bestillingar akkurat no.",
  "Fyll inn navn og e-post": "Fyll inn namn og e-post",
  "Fyll inn adresse, postnummer og poststed": "Fyll inn adresse, postnummer og poststad",
  "Kjøpet er bindende. Selger er {org} (org.nr. {orgnr}) – betalingen går direkte til selgeren.": "Kjøpet er bindande. Seljar er {org} (org.nr. {orgnr}) – betalinga går direkte til seljaren.",
  "Du får ordrebekreftelse på e-post.": "Du får ordrestadfesting på e-post.",
  "Varenr. {sku}": "Varenr. {sku}",

  // Offentleg: ordreside
  "Bestillingen din": "Bestillinga di",
  "Ordre {number}": "Ordre {number}",
  "Fant ikke bestillingen": "Fann ikkje bestillinga",
  "Venter på Vipps": "Ventar på Vipps",
  "Vi venter på bekreftelse fra Vipps. Fullfør betalingen i Vipps-appen – siden oppdateres automatisk.": "Vi ventar på stadfesting frå Vipps. Fullfør betalinga i Vipps-appen – sida blir oppdatert automatisk.",
  "Faktura sendt": "Faktura sendt",
  "Fakturaen er sendt til {email}. Betal {amount} til kontonummer {account} innen {due}, merket {invoice}.": "Fakturaen er sendt til {email}. Betal {amount} til kontonummer {account} innan {due}, merkt {invoice}.",
  "Betalt": "Betalt",
  "Takk! Betalingen er registrert.": "Takk! Betalinga er registrert.",
  "Kansellert": "Kansellert",
  "Bestillingen er kansellert. Er det betalt noe, blir det tilbakebetalt.": "Bestillinga er kansellert. Er det betalt noko, blir det betalt tilbake.",
  "Refundert": "Refundert",
  "Bestillingen er refundert ({amount}).": "Bestillinga er refundert ({amount}).",
  "Klar for henting": "Klar for henting",
  "Sendt": "Sendt",
  "Hentet": "Henta",
  "Ikke behandlet": "Ikkje behandla",
  "Hentested": "Hentestad",
  "Sendes til": "Blir sendt til",
  "Kontakt selger": "Kontakt seljaren",
  "Melding fra selger": "Melding frå seljaren",
  "Din melding": "Meldinga di",
  "Betalingen er avbrutt. Du kan prøve igjen fra varen.": "Betalinga er avbroten. Du kan prøve igjen frå vara.",
  "Fortsett å handle": "Hald fram å handle",

  // Dashbord: oversikt
  "Selg bøker, suvenirer og andre varer ved siden av billettene – med lager, Vipps og faktura.": "Sel bøker, suvenirar og andre varer ved sida av billettane – med lager, Vipps og faktura.",
  "Butikken er åpen": "Butikken er open",
  "Butikken er stengt": "Butikken er stengd",
  "Åpne butikken": "Opne butikken",
  "Steng butikken": "Steng butikken",
  "Opprett vare": "Opprett vare",
  "Ny vare": "Ny vare",
  "Se ordrer": "Sjå ordrar",
  "Åpne offentlig butikk": "Opne offentleg butikk",
  "Kopier lenke": "Kopier lenke",
  "Lenken er kopiert": "Lenka er kopiert",
  "Salg": "Sal",
  "Omsetning": "Omsetnad",
  "Åpne fakturaer": "Opne fakturaer",
  "Lav lagerbeholdning": "Låg lagerbehaldning",
  "Til behandling": "Til behandling",
  "{n} forfalt": "{n} forfalne",
  "{n} utsolgt": "{n} utselde",
  "{n} betalte": "{n} betalte",
  "Ingen betalingsmåte er klar": "Inga betalingsmåte er klar",
  "Legg inn kontonummer for faktura under Innstillinger, eller sett opp Vipps under Betaling. Kunder kan se varene, men ikke bestille før én av dem er på plass.": "Legg inn kontonummer for faktura under Innstillingar, eller set opp Vipps under Betaling. Kundar kan sjå varene, men ikkje bestille før éi av dei er på plass.",
  "Vipps er klart": "Vipps er klart",
  "Faktura er klart": "Faktura er klart",
  "Vipps mangler": "Vipps manglar",
  "Faktura mangler kontonummer": "Faktura manglar kontonummer",
  "Legg til din første vare for å begynne å selge sammen med billettene.": "Legg til den første vara di for å byrje å selje saman med billettane.",
  "Sist oppdatert": "Sist oppdatert",
  "Solgt": "Selt",
  "Vis/skjul": "Vis/skjul",
  "Skjul": "Skjul",
  "Vis": "Vis",
  "Marker utsolgt": "Marker utseld",
  "Slette varen?": "Slette vara?",
  "Varen fjernes fra butikken. Ordrer som allerede er lagt inn beholdes.": "Vara blir fjerna frå butikken. Ordrar som alt er lagde inn blir tekne vare på.",
  "Ja, slett": "Ja, slett",
  "Lager oppdatert": "Lager oppdatert",
  "Endret lager": "Endra lager",
  "Siste ordrer": "Siste ordrar",
  "Ingen ordre": "Ingen ordrar",
  "Når noen kjøper i Butikk, dukker ordrene opp her.": "Når nokon kjøper i Butikk, dukkar ordrane opp her.",
  "Butikken er åpnet": "Butikken er opna",
  "Butikken er stengt for publikum": "Butikken er stengd for publikum",
  "Endre": "Endre",
  "Enter = lagre, Esc = angre": "Enter = lagre, Esc = angre",

  // Dashbord: vareredigering
  "Rediger vare": "Rediger vare",
  "Navn på varen": "Namn på vara",
  "Beskrivelse": "Skildring",
  "Fortell kort om varen – format, størrelse, materiale, hvem den passer for.": "Fortel kort om vara – format, storleik, materiale, kven ho passar for.",
  "Pris (kr)": "Pris (kr)",
  "Varenummer (valgfritt)": "Varenummer (valfritt)",
  "Tildeles automatisk": "Blir tildelt automatisk",
  "Foreslå neste ledige varenummer": "Foreslå neste ledige varenummer",
  "Kunne ikke foreslå varenummer": "Kunne ikkje foreslå varenummer",
  "Bokstaver og tall, må være unikt i butikken din. Tomt felt gir neste ledige nummer (V-0001, V-0002 …).": "Bokstavar og tal, må vere unikt i butikken din. Tomt felt gir neste ledige nummer (V-0001, V-0002 …).",
  "Bokstaver og tall, må være unikt i butikken din. Tømmer du feltet, beholdes dagens nummer.": "Bokstavar og tal, må vere unikt i butikken din. Tømmer du feltet, blir dagens nummer behalde.",
  "Varenummer {sku} er allerede i bruk på «{name}»": "Varenummer {sku} er alt i bruk på «{name}»",
  "Varen er opprettet med varenummer {sku}": "Vara er oppretta med varenummer {sku}",
  "Varen er lagret med varenummer {sku}": "Vara er lagra med varenummer {sku}",
  "Bilde": "Bilete",
  "Last opp bilde": "Last opp bilete",
  "Bytt bilde": "Byt bilete",
  "Fjern bilde": "Fjern bilete",
  "JPG, PNG eller WEBP, maks 5 MB. Lys bakgrunn og hele varen i bildet fungerer best.": "JPG, PNG eller WEBP, maks 5 MB. Lys bakgrunn og heile vara i biletet fungerer best.",
  "Laster opp …": "Lastar opp …",
  "Bildet er lastet opp": "Biletet er lasta opp",
  "Kunne ikke laste opp bildet": "Kunne ikkje laste opp biletet",
  "Antall på lager": "Tal på lager",
  "Varsle ved": "Varsle ved",
  "Du får e-post når lageret er lik eller lavere enn dette tallet. 0 = ingen varsel.": "Du får e-post når lageret er likt eller lågare enn dette talet. 0 = ingen varsel.",
  "Synlig i butikken": "Synleg i butikken",
  "MVA-sats": "MVA-sats",
  "Brukes bare på fakturaen når du er MVA-registrert (se Innstillinger).": "Blir berre brukt på fakturaen når du er MVA-registrert (sjå Innstillingar).",
  "Forhåndsvisning": "Førehandsvising",
  "Slik ser varen ut i butikken": "Slik ser vara ut i butikken",
  "Varen er opprettet": "Vara er oppretta",
  "Varen er lagret": "Vara er lagra",
  "Varen er slettet": "Vara er sletta",
  "Fyll inn navn og pris": "Fyll inn namn og pris",
  "{n} bestillinger med denne varen": "{n} bestillingar med denne vara",

  // Dashbord: ordrar
  "Ordrer i Butikk": "Ordrar i Butikk",
  "Ferdige": "Ferdige",
  "Kansellerte": "Kansellerte",
  "Refunderte": "Refunderte",
  "Søk på ordrenr, navn, e-post eller vare": "Søk på ordrenr, namn, e-post eller vare",
  "Eksporter CSV": "Eksporter CSV",
  "Kjøper": "Kjøpar",
  "Dato": "Dato",
  "Beløp": "Beløp",
  "Marker betalt": "Marker betalt",
  "Sett tilbake til ubetalt": "Set tilbake til ubetalt",
  "Marker sendt": "Marker sendt",
  "Marker hentet": "Marker henta",
  "Kanseller": "Kanseller",
  "Refunder": "Refunder",
  "Kansellere bestillingen?": "Kansellere bestillinga?",
  "Varene legges tilbake på lager og kjøperen får beskjed på e-post. Du kan skrive en kort forklaring til kjøperen.": "Varene blir lagde tilbake på lager og kjøparen får melding på e-post. Du kan skrive ei kort forklaring til kjøparen.",
  "Refundere hele bestillingen?": "Refundere heile bestillinga?",
  "Vipps-betalingen ({amount}) refunderes fra din Vipps-konto til kjøperen, og varene legges tilbake på lager.": "Vipps-betalinga ({amount}) blir refundert frå Vipps-kontoen din til kjøparen, og varene blir lagde tilbake på lager.",
  "Du betaler tilbake {amount} til kjøperen selv (bankoverføring). Bestillingen markeres som refundert og varene legges tilbake på lager.": "Du betaler tilbake {amount} til kjøparen sjølv (bankoverføring). Bestillinga blir markert som refundert og varene blir lagde tilbake på lager.",
  "Begrunnelse til kjøperen (valgfritt)": "Grunngjeving til kjøparen (valfritt)",
  "Ja, kanseller": "Ja, kanseller",
  "Ja, refunder": "Ja, refunder",
  "Forfall {date}": "Forfall {date}",
  "Forfalt": "Forfalle",
  "Faktura {number}": "Faktura {number}",
  "Detaljer": "Detaljar",
  "Ordredetaljer": "Ordredetaljar",
  "Historikk": "Historikk",
  "Sendt {date}": "Sendt {date}",
  "Hentet {date}": "Henta {date}",
  "Betalt {date}": "Betalt {date}",
  "Markert betalt av {by}": "Markert betalt av {by}",
  "Ingen ordre passet filteret": "Ingen ordrar passa filteret",

  // Dashbord: innstillingar
  "Innstillinger for Butikk": "Innstillingar for Butikk",
  "Åpen for publikum": "Open for publikum",
  "Når butikken er åpen, vises varene dine på rightin.no/butikk og på arrangementssidene dine.": "Når butikken er open, blir varene dine viste på rightin.no/butikk og på arrangementssidene dine.",
  "Om butikken": "Om butikken",
  "Kort tekst øverst i butikken din, f.eks. hva dere selger og hva inntektene går til.": "Kort tekst øvst i butikken din, t.d. kva de sel og kva inntektene går til.",
  "Henting hos dere": "Henting hos dykk",
  "Kunden henter varene hos dere etter avtale.": "Kunden hentar varene hos dykk etter avtale.",
  "F.eks. «Kulturhuset, resepsjonen, man–fre 10–15»": "T.d. «Kulturhuset, resepsjonen, mån–fre 10–15»",
  "Kunden oppgir adresse, og fraktprisen legges til bestillingen.": "Kunden oppgir adresse, og fraktprisen blir lagd til bestillinga.",
  "Fast fraktpris (kr)": "Fast fraktpris (kr)",
  "Faktura som betalingsvalg": "Faktura som betalingsval",
  "Right in lager fakturaen (PDF) og sender den til kjøperen. Du markerer bestillingen som betalt når pengene er på konto.": "Right in lagar fakturaen (PDF) og sender han til kjøparen. Du markerer bestillinga som betalt når pengane er på konto.",
  "Kontonummer (11 siffer)": "Kontonummer (11 siffer)",
  "Forfall (dager)": "Forfall (dagar)",
  "Melding på fakturaen (valgfritt)": "Melding på fakturaen (valfritt)",
  "MVA-registrert": "MVA-registrert",
  "Når dette er på, viser fakturaen MVA-beløpet (prisene dine er inkl. MVA).": "Når dette er på, viser fakturaen MVA-beløpet (prisane dine er inkl. MVA).",
  "Vipps som betalingsvalg": "Vipps som betalingsval",
  "Vipps bruker det samme oppsettet som billettene dine (Betaling i menyen). Pengene går rett til din Vipps-konto.": "Vipps brukar det same oppsettet som billettane dine (Betaling i menyen). Pengane går rett til Vipps-kontoen din.",
  "Sett opp Vipps": "Set opp Vipps",
  "Varsler": "Varsel",
  "E-post ved ny bestilling": "E-post ved ny bestilling",
  "E-post ved lavt lager": "E-post ved lågt lager",
  "Send varsler til (valgfritt)": "Send varsel til (valfritt)",
  "Tom = kontoens e-postadresse": "Tom = e-postadressa til kontoen",
  "Innstillingene er lagret": "Innstillingane er lagra",
  "Kontonummeret må ha 11 siffer": "Kontonummeret må ha 11 siffer",
  "Right in tar ingen avgift på butikksalg.": "Right in tek inga avgift på butikksal.",

  // Offentleg: tillegg (kasse/ordre/marknadsplass)
  "Bestill": "Bestill",
  "Lukk": "Lukk",
  "Butikken til {org}": "Butikken til {org}",
  "Frakt {price}": "Frakt {price}",
  "Gratis frakt": "Gratis frakt",
  "Henting eller sending i posten": "Henting eller sending i posten",
  "Kontonummer": "Kontonummer",
  "Mottatt": "Motteken",
  "Om varen": "Om vara",
  "Prøv et annet søkeord, eller fjern filteret.": "Prøv eit anna søkjeord, eller fjern filteret.",
  "Selger er {org} (org.nr. {orgnr}). Betalingen går direkte til selgeren – Right in formidler bare bestillingen.": "Seljar er {org} (org.nr. {orgnr}). Betalinga går direkte til seljaren – Right in formidlar berre bestillinga.",
  "Vi har ikke fått bekreftelse enda. Hvis du har betalt, prøv å oppdatere siden.": "Vi har ikkje fått stadfesting enno. Har du betalt, prøv å oppdatere sida.",

  // Phase 73: handlekorg, lagerhistorikk, fakturapåminning
  "Automatisk": "Automatisk",
  "Automatisk påminnelse ved forfalt faktura": "Automatisk påminning ved forfallen faktura",
  "Bare {n} igjen": "Berre {n} att",
  "Bytte butikk?": "Byte butikk?",
  "Fortsett å handle hos {org}": "Hald fram med å handle hos {org}",
  "Frakt (ved sending) og totalsum ser du i oppsummeringen før du bestiller.": "Frakt (ved sending) og totalsum ser du i oppsummeringa før du bestiller.",
  "Handlekurv ({n})": "Handlekorg ({n})",
  "Handlekurven din har varer fra {other}. Du kan bare handle hos én arrangør om gangen – vil du tømme kurven og legge til {name} i stedet?": "Handlekorga di har varer frå {other}. Du kan berre handle hos éin arrangør om gongen – vil du tømme korga og leggje til {name} i staden?",
  "Handlekurven er full (maks {n} ulike varer)": "Handlekorga er full (maks {n} ulike varer)",
  "Handlekurven er tom": "Handlekorga er tom",
  "Ingen lagerendringer ennå.": "Ingen lagerendringar enno.",
  "Justert": "Justert",
  "Kassen": "Kassa",
  "Kjøperen får én påminnelse på e-post 3 dager etter forfall (med fakturaen vedlagt). Du får kopi. Du kan også sende påminnelse manuelt fra ordrelisten.": "Kjøparen får éi påminning på e-post 3 dagar etter forfall (med fakturaen vedlagd). Du får kopi. Du kan òg sende påminning manuelt frå ordrelista.",
  "Kunne ikke laste lagerhistorikken": "Kunne ikkje laste lagerhistorikken",
  "Lagerhistorikk": "Lagerhistorikk",
  "Lagt i handlekurven": "Lagt i handlekorga",
  "Legg i handlekurv": "Legg i handlekorg",
  "Legg til varer fra butikken, så finner du dem igjen her.": "Legg til varer frå butikken, så finn du dei att her.",
  "Levering og betaling": "Levering og betaling",
  "Maks {n} av denne varen": "Maks {n} av denne vara",
  "Noen varer er ikke tilgjengelige lenger og ble fjernet fra handlekurven: {names}": "Nokre varer er ikkje tilgjengelege lenger og vart fjerna frå handlekorga: {names}",
  "Opprettet": "Oppretta",
  "Påminnelse sendt": "Påminning sendt",
  "Påminnelse sendt i dag": "Påminning sendt i dag",
  "Påminnet {date}": "Påminna {date}",
  "Salg, påfyll og hvem som endret lageret – nyeste øverst.": "Sal, påfyll og kven som endra lageret – nyaste øvst.",
  "Selger: {org}": "Seljar: {org}",
  "Send påminnelse": "Send påminning",
  "Send påminnelse igjen": "Send påminning igjen",
  "Til butikken": "Til butikken",
  "Til kassen": "Til kassa",
  "Tilbake på lager": "Tilbake på lager",
  "Tøm handlekurven": "Tøm handlekorga",
  "Tøm og legg til": "Tøm og legg til",
  "Varesum": "Varesum",
  "en annen arrangør": "ein annan arrangør",
  "per stk.": "per stk.",
  "{name} er lagt i handlekurven": "{name} er lagd i handlekorga",
  "{n} stk. ligger allerede i handlekurven": "{n} stk. ligg alt i handlekorga",
  // Varesøk, sortering og strekkodar (Phase 73c)
  "Søk på navn eller varenummer": "Søk på namn eller varenummer",
  "Tøm søk": "Tøm søk",
  "Sorter": "Sorter",
  "Nyeste først": "Nyaste først",
  "Varenummer": "Varenummer",
  "Varenr.": "Varenr.",
  "Hyllekort eller etikettark med strekkode og QR": "Hyllekort eller etikettark med strekkode og QR",
  "Strekkoder": "Strekkodar",
  "Prøv et annet navn eller varenummer.": "Prøv eit anna namn eller varenummer.",
  "Strekkode / etikett": "Strekkode / etikett",
  "Ordrer med varen": "Ordrar med vara",
  "Søk på ordrenr, navn, e-post, vare eller varenr.": "Søk på ordrenr, namn, e-post, vare eller varenr.",
  "Ordrer med {name}": "Ordrar med {name}",
  "Ordrer med valgt vare": "Ordrar med vald vare",
  "Fjern varefilter": "Fjern varefilter",
  "Etikettark er klart ({n} ark)": "Etikettarket er klart ({n} ark)",
  "Hyllekort er klare ({n} stk.)": "Hyllekorta er klare ({n} stk.)",
  "Skriv ut strekkode og QR": "Skriv ut strekkode og QR",
  "Vare: {name}": "Vare: {name}",
  "{n} varer valgt": "{n} varer valde",
  "QR-koden lenker til varesiden i butikken, strekkoden (Code 128) er varenummeret.": "QR-koden lenkjer til varesida i butikken, strekkoden (Code 128) er varenummeret.",
  "Hyllekort (A6)": "Hyllekort (A6)",
  "Ett kort per vare med navn, pris, stor QR og strekkode": "Eitt kort per vare med namn, pris, stor QR og strekkode",
  "Etikettark (A4)": "Etikettark (A4)",
  "70 × 37 mm, 24 etiketter per ark – til poser og utlevering": "70 × 37 mm, 24 etikettar per ark – til posar og utlevering",
  "Etiketter per vare": "Etikettar per vare",
  "Papir": "Papir",
  "Vis skjærelinjer (vanlig papir)": "Vis skjerelinjer (vanleg papir)",
  "{labels} etiketter på {sheets} ark": "{labels} etikettar på {sheets} ark",
  "{n} hyllekort (én side per vare)": "{n} hyllekort (éi side per vare)",
  "Maks {n} etiketter om gangen – reduser antall per vare.": "Maks {n} etikettar om gongen – reduser talet per vare.",
  "{n} av varene mangler varenummer og får bare QR-kode. Lagre varen én gang i vareredigeringen, så får den et nummer automatisk.": "{n} av varene manglar varenummer og får berre QR-kode. Lagre vara éin gong i vareredigeringa, så får ho eit nummer automatisk.",
  "Åpne og skriv ut": "Opne og skriv ut",
  "Kunne ikke lage PDF": "Kunne ikkje lage PDF",
  // Lagerteljing (Phase 73d)
  "Lagertelling": "Lagerteljing",
  "Telleliste til utskrift og registrering av opptalt antall": "Teljeliste til utskrift og registrering av opptalt tal",
  "Skriv ut tellelisten, tell varene fysisk og tast inn opptalt antall her. Lageret rettes til det du har talt, og avvikene føres i lagerhistorikken som «Lagertelling».": "Skriv ut teljelista, tel varene fysisk og tast inn opptalt tal her. Lageret blir retta til det du har talt, og avvika blir førte i lagerhistorikken som «Lagerteljing».",
  "Skriv ut telleliste": "Skriv ut teljeliste",
  "Kunne ikke laste varene": "Kunne ikkje laste varene",
  "Ingen varer å telle ennå": "Ingen varer å telje enno",
  "Opprett varer i butikken først, så kan du telle dem her.": "Opprett varer i butikken først, så kan du telje dei her.",
  "Telling registrert": "Teljing registrert",
  "Telling registrert: {counted} varer talt, {changed} med avvik": "Teljing registrert: {counted} varer talde, {changed} med avvik",
  "Telling registrert {time}": "Teljing registrert {time}",
  "{counted} varer talt · {changed} med avvik · manko {missing} · overskudd {surplus}": "{counted} varer talde · {changed} med avvik · manko {missing} · overskot {surplus}",
  "Setter opptalt = systemtall for varer du ikke har fylt ut": "Set opptalt = systemtal for varer du ikkje har fylt ut",
  "Fyll tomme med systemtall": "Fyll tomme med systemtal",
  "Nullstill": "Nullstill",
  "Lager (system)": "Lager (system)",
  "Opptalt": "Opptalt",
  "Avvik": "Avvik",
  "Stemmer": "Stemmer",
  "System": "System",
  "Opptalt antall for {name}": "Opptalt tal for {name}",
  "av": "av",
  "varer talt": "varer talde",
  "med avvik": "med avvik",
  "manko": "manko",
  "overskudd": "overskot",
  "Merknad (valgfritt)": "Merknad (valfritt)",
  "F.eks. «Telling før julemarkedet»": "T.d. «Teljing før julemarknaden»",
  "Registrer telling": "Registrer teljing",
  "Siste tellinger": "Siste teljingar",
  "Ingen tellinger registrert ennå.": "Ingen teljingar registrerte enno.",
  "{counted} talt · {changed} avvik": "{counted} talde · {changed} avvik",
  "Registrere tellingen?": "Registrere teljinga?",
  "{n} varer talt – alt stemmer med systemet. Ingen lagertall endres, men tellingen lagres i historikken.": "{n} varer talde – alt stemmer med systemet. Ingen lagertal blir endra, men teljinga blir lagra i historikken.",
  "{n} varer talt. Lageret på {changed} varer rettes til opptalt antall, og avvikene føres i lagerhistorikken.": "{n} varer talde. Lageret på {changed} varer blir retta til opptalt tal, og avvika blir førte i lagerhistorikken.",
};
